import { Text } from '@mantine/core';
import type { FC } from 'react';

type Props = {
  questionText: string;
};

const QuestionText: FC<Props> = ({ questionText }) => {
  return (
    <Text fw={500} color='black'>
      {questionText}
    </Text>
  );
};

export default QuestionText;
